import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { FiPhoneIncoming } from "react-icons/fi";
import { BsXLg } from "react-icons/bs";
import { getAutodropTime, millisecondsToSeconds } from '../../../utils/utils';

const IncomingCallPopup = () => {
	const contactObj = useSelector((state: any) => { return state.contactSlice.contactObj })
	const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
	const [agentCurrentState, setAgentCurrentState] = useState<any>("");
	const [contactAttributes, setContactAttributes] = useState<any>({})
	const [isDisabled, setIsDisabled] = useState<any>(false)
	const [isAcceptDisabled, setIsAcceptDisabled] = useState<any>(false)
	const [isRejectDisabled, setIsRejectDisabled] = useState<any>(false)
	const [queueName, setQueueName] = useState<any>();
	const [contactNo, setContactNo] = useState<any>("");
	const [show, setShow] = useState(false);
	const [autodropTimeState, setAutodropTimeState] = useState(0);

	useEffect(() => {
		{ console.dir("These are the contactAttributes " + JSON.stringify(contactAttributes)) }
		let interval: any;
		if (agentObj) {
			let agentState = agentObj.getState().name;
			if (agentState === 'PendingBusy' || agentState === 'Pending') {
				handleShow()
			}
			setAgentCurrentState(agentState)

			agentObj?.onRefresh(() => {
				let agentState = agentObj.getState().name;
				if (agentState !== 'PendingBusy' || agentState === 'Pending') {
					handleClose()
				}
				setAgentCurrentState(agentState)
			})
		}
		if (contactObj) {
			try {
				let snapshotData = contactObj?.toSnapshot()
				let connection = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type !== "agent"))[0]
				setContactNo(connection?.endpoint?.phoneNumber)
				setContactAttributes(contactObj.getAttributes())
				setQueueName(contactObj.getQueue())
				contactObj?.onRefresh(() => {
					let snapshotData = contactObj?.toSnapshot()
					let connection = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type !== "agent"))[0]
					setContactNo(connection?.endpoint?.phoneNumber)
					setContactAttributes(contactObj.getAttributes())
					setQueueName(contactObj.getQueue())
				})

				interval = setInterval(() => {
					try {
						let autodropTime = getAutodropTime(contactObj?.getQueue()?.name, contactObj?.getType())
						let contactDirection = contactObj.isInbound() ? "inbound" : "outbound"
						if (contactObj.getState().type === 'connecting' && autodropTime > 0 && contactDirection === "inbound") {
							let callDuration = millisecondsToSeconds(contactObj?.getStatusDuration())
							let remainTime = autodropTime - callDuration
							if (remainTime > 0) {
								setAutodropTimeState(autodropTime - callDuration)
							} else {
								contactObj?.getAgentConnection().destroy();
							}
						} else {
							clearInterval(interval)
						}
					} catch (err) {
						console.log(err)
						clearInterval(interval)
					}
				}, 1000);
			} catch (error) {
				console.log(error)
			}
		}
		return () => {
			clearInterval(interval)
		}
	}, [agentObj, contactObj])

	const handleClose = () => {
		setIsAcceptDisabled(false)
		setIsRejectDisabled(false)
		setIsDisabled(false)
		setShow(false)
	};
	const handleShow = () => setShow(true);

	const onAcceptCall = () => {
		setIsDisabled(true)
		setIsAcceptDisabled(true)


		if(process.env.REACT_APP_AWS_CCP_AutoITSMlink === "1") {
		if(contactAttributes?.ServiceNowLookup?.value) {window.open(contactAttributes?.ServiceNowLookup?.value); }
		}

		contactObj.accept({
			success: function () {
				console.log("ConnectionComponent::onAcceptCall::Call Accepted Succesfully");
			},
			failuer: function (err: any) {
				console.log("ConnectionComponent::onAcceptCall::Error in Call Accept" + err);
			}
		})
	}

	const onRejectCall = () => {
		setIsDisabled(true)
		setIsRejectDisabled(true)
		contactObj.reject({
			success: function () {
				console.log("ConnectionComponent::onRejectCall::Call Rejected Succesfully");
			},
			failuer: function (err: any) {
				console.log("ConnectionComponent::onRejectCall::Error in Call Reject" + err);
			}
		})
	}

	return (
		<React.Fragment>

			{(agentCurrentState === "PendingBusy" || agentCurrentState === 'Pending') &&
				<Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
					<Modal.Header className='dailpad-header'>
						<Modal.Title className='text-darkblue'>Alert</Modal.Title>
						<button className='close-btn-x' onClick={handleClose}>
							<BsXLg />
						</button>
					</Modal.Header>
					<Modal.Body>

						<div className='row'>

							<div className='col-12'>
								<div className='incomming-box text-center'>
									{autodropTimeState > 0 && <label className='text-danger'><strong>Call will autodrop in {autodropTimeState} seconds</strong></label>}
									<div className='incomming-call-icon text-success'><FiPhoneIncoming /></div>
									<h6 className='mt-3 mb-0 text-darkblue'>Incoming call</h6>
									<h4 className='fw-bold text-darkblue'>{contactNo}</h4>
									<h6 className='mt-4 mb-0 text-darkblue'>{contactAttributes?.Language?.value || ""}</h6>
									<h6 className='text-darkblue'>{queueName?.name || ""}</h6>

									{
										contactAttributes?.Account?.value && <h6 className='text-darkblue'>Account: {contactAttributes?.Account?.value || ""}</h6>
									}


									{
										contactAttributes?.AccountName?.value &&
										<h6 className='text-darkblue'>Account Name: {contactAttributes?.AccountName?.value || ""}</h6>
									}

									{
										contactAttributes?.Site?.value &&
										<h6 className='text-darkblue'>Site: {contactAttributes?.Site?.value || ""}</h6>
									}

									{
										contactAttributes?.ServiceType?.value &&
										<h6 className='text-darkblue'>Service Type: {contactAttributes?.ServiceType?.value || ""}</h6>
									}

									{contactAttributes?.QueueNames?.value &&
										<h6 className='text-darkblue'>Queue Names: {contactAttributes?.QueueNames?.value || ""}</h6>

									}
									<br />
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-12 text-center'>
								<Button disabled={isDisabled} onClick={() => { onAcceptCall() }} className='mw-100 me-2' variant="primary">
									{isAcceptDisabled && <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />} Accept
								</Button>
								<Button disabled={isDisabled} onClick={() => { onRejectCall() }} className='mw-100' variant="danger">
									{isRejectDisabled && <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />} Decline
								</Button>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			}
		</React.Fragment>
	)
}
export default IncomingCallPopup;